import { memo, useMemo } from 'react';
import Porcentajes from '../complementos/Porcentajes';
import { Box, Typography } from '@mui/material';
import Apercibidos from '../complementos/Apercibidos';
import useStatusIcon from '@/DesignSystem/hooks/useStatusIcon';
import TshirtIconComponent from '@/components/page-components/fixtures/fixture-player-stadium-player/tshirt-icon-component';
import PuntuacionConfirmada from '../complementos/PuntuacionConfirmada';
import JugadorEventCard from './JugadorEventCard';
import CustomPlayerImageWithDefault from '@/components/shared/custom/CustomPlayerImageWithDefault';

const JugadoresSuplenteTitularCard = memo(
    ({
        player,
        mode,
        direction = 'row',
        align = 'flex-end',
        events,
        estadisticasPartido,
        showPercentage = true,
    }) => {
        const status = useStatusIcon({
            status: player.status,
            statusLevel: player.statusLevel,
            width: 12,
            height: 12,
            skipIfNotOk: true,
        });

        const playerEvents = useMemo(() => {
            return events?.filter(
                (event) =>
                    (event.player.id === player.id && event.player.id) ||
                    (event.assist.id === player.id && event.assist.id)
            );
        }, [events, player.id]);

        const puntuacion = useMemo(() => {
            return estadisticasPartido?.estadisticas?.[player.id];
        }, [estadisticasPartido, player.id]);

        return (
            <Box display="flex" alignItems="center" gap={1} flexDirection={direction} py={0.5}>
                <Box
                    width={50}
                    height={50}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    {player.id > 0 && (
                        <CustomPlayerImageWithDefault
                            playerId={player.id}
                            alt={player.name}
                            width={50}
                            height={50}
                            style={{ borderRadius: '50%' }}
                            coeficiente={1}
                        />
                    )}

                    {!player.id && (
                        <TshirtIconComponent
                            primary={player.primary}
                            colorNumber={player.colorNumber}
                            number={player.number}
                            width={50}
                            height={50}
                            fontSize={14}
                        />
                    )}
                </Box>

                <Box display="flex" alignItems={align} flexDirection="column">
                    {mode === 'predict' && showPercentage && (
                        <Porcentajes porcentaje={player.chance} fontSize={10} width="30px" height="15px" />
                    )}
                    <Box display="flex" alignItems="center" gap={0.5} flexDirection={direction}>
                        <Typography fontSize={14} textAlign="center" noWrap>
                            {player.name}
                        </Typography>
                        {status}
                        <Apercibidos cards={player.cards} />
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.25} flexDirection={direction}>
                        {puntuacion && <PuntuacionConfirmada estadisticaPartido={puntuacion} fontSize={10} />}
                        {playerEvents?.map((event, index) => (
                            <JugadorEventCard
                                key={`${event.id}-${index}`}
                                event={event}
                                player={player}
                                direction={direction}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    }
);

JugadoresSuplenteTitularCard.displayName = 'JugadoresSuplenteTitularCard';

export default JugadoresSuplenteTitularCard;
